import axios from "axios";
import axiosConstants from "../axiosConstants";
import { RequestResponse, User } from "../types";

export const getUsersAndPermissions: () => Promise<
  RequestResponse<User>
> = async () => {
  try {
    const userRequest = axios.get(axiosConstants.USER_URL);
    const permissionsRequest = axios.get(axiosConstants.PERMISSIONS_URL);
    const [userResponse, permissionsResponse] = await Promise.all([
      userRequest,
      permissionsRequest
    ]);

    const permissionsMap = permissionsResponse.data.reduce(
      (map: Record<string, boolean>, permission: any) => ({
        ...map,
        [permission.authority]: true
      }),
      {}
    );

    const data: User = {
      ...userResponse.data,
      userType: "ISW_ADMIN",
      permissionsMap
    };
    return { error: false, data };
  } catch (e) {
    console.log("Error fetching user data: ", e);
    return {
      error: true,
      message: `Error fetching user data: ${e.message}`,
      data: null
    };
  }
};
